import times from 'lodash/times';

export const computeRiskBands = (bandsCount: number) => {
  const remainder = 100 % bandsCount;
  const bandSize = Math.floor(100 / bandsCount);

  return times(bandsCount).map(index => {
    const bandStart = index * bandSize + 1;
    const bandEnd = (index + 1) * bandSize + (index === bandsCount - 1 ? remainder : 0);

    return [bandStart, bandEnd];
  });
};
